import React, { useState, useEffect } from "react";
import { FaQuoteRight } from "react-icons/fa";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { BsSlashLg } from "react-icons/bs";
// import { motion } from "framer-motion";
//import axios from "axios";

function Review() {
  const [People, setPeople] = useState(null);
  const [index, setIndex] = useState(0);
  const [Data, setData] = useState();

  useEffect(() => {

  /*   fetch("http://localhost:5000/user/get_all_posted_team")
      .catch((err) => console.log(err.message))
      .then((res) => res.json())
      .then((data) => {
        setPeople(data);
        setData(data.length - 1);
       
      }); */
      setData(3-1);
       setPeople([
        {
          TeamPost_id:"1",
           Picture:"cmss-edu.jpeg",
          FullName:"Prof Abubakar Sani Sambo",
          Postion:"Commissioner Of Education",
          Article:" Education is the foundation upon which we build our dreams, the compass guiding us toward a future of boundless possibilities"
        } ,
         {
          TeamPost_id:"2",
          Picture:"es.jpg_large",
          FullName:"Professor Yahya Saleh Ibrahim",
          Postion:"The Executive Secretary of The Board",
          Article:"Education is the key that unlocks the doors of opportunity, empowering minds to illuminate the world with knowledge and wisdom"
        } ,
       
       ]);


  }, []); 

  useEffect(() => {
    const lastIndex = Data;

    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, People]);

  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index + 1);
      
    }, 9000);

    return () => clearInterval(slider);
  }, [index]);

  return (
    <div
      className="review-con"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, paddingTop: "6em" }}
      exit={{ opacity: 0, transition: { duration: 0.1 }, paddingTop: "0em" }}
    >
      <h1 className="h1 flex pt-2 whitespace-nowrapi">
        <small className="b-icon-">
          <BsSlashLg />
        </small>
        KEY STAKEHOLDERS
      </h1>

      <div className="review-inner-con">
        {People !== null &&
          People.map((person, personidex) => {
            const { TeamPost_id, Picture, FullName, Postion, Article } = person;

            let position = "nextSlide";
            if (personidex === index) {
              position = "activeSlide";
            }
            if (
              personidex === index - 1 ||
              (index === 0 && personidex === People.length - 1)
            ) {
              position = "lastSlide";
            }
            return (
              <article key={personidex} className={position}>
                <img
                  className="rounded-full shadow-2xl h-32 w-32"
                  src={`/assets/${Picture}`}
                  alt=""
                />
                <h3 className="pt-4 whitespace-nowrap">
                  <b>{FullName}</b>
                </h3>
                <p>
                  <b>{Postion}</b>
                </p>
                <p>
                  <sub>{Article}</sub>{" "}
                </p>
                <b className="b-icon- mt-4">
                  <FaQuoteRight />
                </b>
              </article>
            );
          })}
        <button className="prev" onClick={() => setIndex(index - 1)}>
          <FiChevronLeft />
        </button>
        <button className="next" onClick={() => setIndex(index + 1)}>
          <FiChevronRight />
        </button>
      </div>
    </div>
  );
}

export default Review;
